// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Outer container ────────────────────────────────────────────────────── */

.intervalTimetable_intervalDisplay_oWmkj {
  position: relative;
  color: black;
  /* Stretch to fill .root including its horizontal padding */
  margin-left: calc(-1 * var(--border-radius) / 2);
  margin-right: calc(-1 * var(--border-radius) / 2);
  padding-left: calc(var(--border-radius) / 2);
  padding-right: calc(var(--border-radius) / 2);
}

/* ─── Stripe background — absolutely fills the container ─────────────────── */

.intervalTimetable_stripeBackground_QO7tP {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  pointer-events: none;
  /* padding-top/bottom set inline to align stripes with interval rows */
}

.intervalTimetable_stripeRow_mLCva {
  width: 100%;
  flex-shrink: 0;
}

.intervalTimetable_stripeRowAlt_daG0t {
  background-color: var(--timetable-accent-color);
}

/* ─── Column layout — on top of stripes ──────────────────────────────────── */

.intervalTimetable_columnLayout_QhMri {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: row;
  align-items: stretch;
}

.intervalTimetable_routeGroupsContainer_jjvAC {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  gap: 6px;
}

/* ─── Hours column ───────────────────────────────────────────────────────── */

.intervalTimetable_hoursColumn_sItUE {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

/* ─── Route group wrapper — single border element ────────────────────────── */

.intervalTimetable_routeGroup_jwB8O {
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  margin: 0 3px;
}

.intervalTimetable_routeGroupBordered_nDZVI {
  border: 2px solid;
}

/* ─── Individual route column ────────────────────────────────────────────── */

.intervalTimetable_routeColumn_RxklY {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 60px;
  padding: 0 4px;
}

/* ─── Combined headway column — left border separator ────────────────────── */

.intervalTimetable_combinedColumn_ODgAs {
  position: relative;
  width: max-content;
  min-width: max-content;
  flex-shrink: 0;
}

.intervalTimetable_combinedColumn_ODgAs::before {
  content: '';
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 2px;
  background-color: var(--combined-separator-color);
}

/* ─── Heading cell (fixed height set inline) ─────────────────────────────── */

.intervalTimetable_headingCell_osNSt {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
}

/* ─── Departure value cell (fixed height set inline) ─────────────────────── */

.intervalTimetable_departureCell_vJ_hT {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  width: 100%;
  box-sizing: border-box;
}

/* ─── Label cell in hours column (fixed height set inline) ───────────────── */

.intervalTimetable_labelCell_ETbjk {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

/* ─── Individual interval cell (height set inline) ───────────────────────── */

.intervalTimetable_intervalCell_MdpoN {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
}

/* ─── Hours interval cell (height set inline) ────────────────────────────── */

.intervalTimetable_intervalHoursCell_ALxw6 {
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

/* ─── Route heading ──────────────────────────────────────────────────────── */

.intervalTimetable_routeHeadings__pfZS {
  display: flex;
  gap: 0.2em;
  font-size: 20px;
  align-items: center;
}

/* ─── Combined headway heading text ─────────────────────────────────────── */

.intervalTimetable_combinedHeading_A36gx {
  display: flex;
  flex-direction: column;
  font-size: 11px;
  line-height: 1.3;
  text-align: center;
  white-space: nowrap;
}

/* ─── Departure label stacks ─────────────────────────────────────────────── */

.intervalTimetable_departureTitles_zgtHp {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  line-height: 1.3;
}

/* ─── Two-panel split layout ─────────────────────────────────────────────── */

.intervalTimetable_flexContainer_fi3Uv {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: calc((1 * var(--border-radius)) + 8px);
}

.intervalTimetable_leftPanel_c_h1M {
  flex: 1 1 auto;
  min-width: 0;
}

.intervalTimetable_rightPanel_nObf9 {
  flex: 1 1 300px;
  min-width: 300px;
}

/* ─── Stacked layout (normal timetable has more rows than interval) ────────── */

.intervalTimetable_stackedLayout_dvWtk {
  flex-direction: column;
}

.intervalTimetable_topPanel_qmMAM {
  width: 100%;
}

.intervalTimetable_bottomPanel_qYMmE {
  width: 100%;
}

.intervalTimetable_busRoutesContainer_H9t28 {
  display: flex;
  gap: 12px;
  padding: 0 0 0.4em 0.938em;
}

/* ─── Depot column (H) ───────────────────────────────────────────────────── */

.intervalTimetable_depotColumn_xvd6_ {
  position: relative;
  min-width: 0;
}

.intervalTimetable_depotColumn_xvd6_::before {
  content: '';
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 2px;
  background-color: var(--depot-separator-color);
}

.intervalTimetable_depotMinutes_keo79 {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  padding: 0 2px;
}

.intervalTimetable_depotMinutes_keo79 > * {
  min-width: 0;
  padding: 0;
  margin-right: 0.15em;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/components/timetable/intervalTimetable.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,YAAY;EACZ,2DAA2D;EAC3D,gDAAgD;EAChD,iDAAiD;EACjD,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,sEAAsE;AACxE;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,+CAA+C;AACjD;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;EAC3B,QAAQ;AACV;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,iDAAiD;AACnD;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,UAAU;EACV,eAAe;EACf,mBAAmB;AACrB;;AAEA,8EAA8E;;AAE9E;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,iFAAiF;;AAEjF;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA,+EAA+E;;AAE/E;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,eAAe;AACjB","sourcesContent":["/* ─── Outer container ────────────────────────────────────────────────────── */\n\n.intervalDisplay {\n  position: relative;\n  color: black;\n  /* Stretch to fill .root including its horizontal padding */\n  margin-left: calc(-1 * var(--border-radius) / 2);\n  margin-right: calc(-1 * var(--border-radius) / 2);\n  padding-left: calc(var(--border-radius) / 2);\n  padding-right: calc(var(--border-radius) / 2);\n}\n\n/* ─── Stripe background — absolutely fills the container ─────────────────── */\n\n.stripeBackground {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  pointer-events: none;\n  /* padding-top/bottom set inline to align stripes with interval rows */\n}\n\n.stripeRow {\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.stripeRowAlt {\n  background-color: var(--timetable-accent-color);\n}\n\n/* ─── Column layout — on top of stripes ──────────────────────────────────── */\n\n.columnLayout {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n}\n\n.routeGroupsContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  justify-content: flex-start;\n  gap: 6px;\n}\n\n/* ─── Hours column ───────────────────────────────────────────────────────── */\n\n.hoursColumn {\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n}\n\n/* ─── Route group wrapper — single border element ────────────────────────── */\n\n.routeGroup {\n  display: flex;\n  flex-direction: row;\n  border-radius: 8px;\n  margin: 0 3px;\n}\n\n.routeGroupBordered {\n  border: 2px solid;\n}\n\n/* ─── Individual route column ────────────────────────────────────────────── */\n\n.routeColumn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 60px;\n  padding: 0 4px;\n}\n\n/* ─── Combined headway column — left border separator ────────────────────── */\n\n.combinedColumn {\n  position: relative;\n  width: max-content;\n  min-width: max-content;\n  flex-shrink: 0;\n}\n\n.combinedColumn::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 8px;\n  bottom: 8px;\n  width: 2px;\n  background-color: var(--combined-separator-color);\n}\n\n/* ─── Heading cell (fixed height set inline) ─────────────────────────────── */\n\n.headingCell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* ─── Departure value cell (fixed height set inline) ─────────────────────── */\n\n.departureCell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* ─── Label cell in hours column (fixed height set inline) ───────────────── */\n\n.labelCell {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n/* ─── Individual interval cell (height set inline) ───────────────────────── */\n\n.intervalCell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* ─── Hours interval cell (height set inline) ────────────────────────────── */\n\n.intervalHoursCell {\n  display: flex;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n/* ─── Route heading ──────────────────────────────────────────────────────── */\n\n.routeHeadings {\n  display: flex;\n  gap: 0.2em;\n  font-size: 20px;\n  align-items: center;\n}\n\n/* ─── Combined headway heading text ─────────────────────────────────────── */\n\n.combinedHeading {\n  display: flex;\n  flex-direction: column;\n  font-size: 11px;\n  line-height: 1.3;\n  text-align: center;\n  white-space: nowrap;\n}\n\n/* ─── Departure label stacks ─────────────────────────────────────────────── */\n\n.departureTitles {\n  display: flex;\n  flex-direction: column;\n  font-size: 13px;\n  line-height: 1.3;\n}\n\n/* ─── Two-panel split layout ─────────────────────────────────────────────── */\n\n.flexContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: calc((1 * var(--border-radius)) + 8px);\n}\n\n.leftPanel {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.rightPanel {\n  flex: 1 1 300px;\n  min-width: 300px;\n}\n\n/* ─── Stacked layout (normal timetable has more rows than interval) ────────── */\n\n.stackedLayout {\n  flex-direction: column;\n}\n\n.topPanel {\n  width: 100%;\n}\n\n.bottomPanel {\n  width: 100%;\n}\n\n.busRoutesContainer {\n  display: flex;\n  gap: 12px;\n  padding: 0 0 0.4em 0.938em;\n}\n\n/* ─── Depot column (H) ───────────────────────────────────────────────────── */\n\n.depotColumn {\n  position: relative;\n  min-width: 0;\n}\n\n.depotColumn::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 8px;\n  bottom: 8px;\n  width: 2px;\n  background-color: var(--depot-separator-color);\n}\n\n.depotMinutes {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  padding: 0 2px;\n}\n\n.depotMinutes > * {\n  min-width: 0;\n  padding: 0;\n  margin-right: 0.15em;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"intervalDisplay": `intervalTimetable_intervalDisplay_oWmkj`,
	"stripeBackground": `intervalTimetable_stripeBackground_QO7tP`,
	"stripeRow": `intervalTimetable_stripeRow_mLCva`,
	"stripeRowAlt": `intervalTimetable_stripeRowAlt_daG0t`,
	"columnLayout": `intervalTimetable_columnLayout_QhMri`,
	"routeGroupsContainer": `intervalTimetable_routeGroupsContainer_jjvAC`,
	"hoursColumn": `intervalTimetable_hoursColumn_sItUE`,
	"routeGroup": `intervalTimetable_routeGroup_jwB8O`,
	"routeGroupBordered": `intervalTimetable_routeGroupBordered_nDZVI`,
	"routeColumn": `intervalTimetable_routeColumn_RxklY`,
	"combinedColumn": `intervalTimetable_combinedColumn_ODgAs`,
	"headingCell": `intervalTimetable_headingCell_osNSt`,
	"departureCell": `intervalTimetable_departureCell_vJ_hT`,
	"labelCell": `intervalTimetable_labelCell_ETbjk`,
	"intervalCell": `intervalTimetable_intervalCell_MdpoN`,
	"intervalHoursCell": `intervalTimetable_intervalHoursCell_ALxw6`,
	"routeHeadings": `intervalTimetable_routeHeadings__pfZS`,
	"combinedHeading": `intervalTimetable_combinedHeading_A36gx`,
	"departureTitles": `intervalTimetable_departureTitles_zgtHp`,
	"flexContainer": `intervalTimetable_flexContainer_fi3Uv`,
	"leftPanel": `intervalTimetable_leftPanel_c_h1M`,
	"rightPanel": `intervalTimetable_rightPanel_nObf9`,
	"stackedLayout": `intervalTimetable_stackedLayout_dvWtk`,
	"topPanel": `intervalTimetable_topPanel_qmMAM`,
	"bottomPanel": `intervalTimetable_bottomPanel_qYMmE`,
	"busRoutesContainer": `intervalTimetable_busRoutesContainer_H9t28`,
	"depotColumn": `intervalTimetable_depotColumn_xvd6_`,
	"depotMinutes": `intervalTimetable_depotMinutes_keo79`
};
module.exports = ___CSS_LOADER_EXPORT___;
